import classNames from "classnames";
import { FunctionComponent } from "react";

import { IProps } from "./anomaly-detail.types";
import "./anomaly-detail.scss";

/**
 * Display some detail about an anomaly with an icon and label.
 * @param props.label     Label describing detail.
 * @param props.size      Font size.
 * @param props.styleName Optional colour.
 * @param props.value     Value of the detail.
 * @returns
 */
const AnomalyDetail: FunctionComponent<IProps> = ({ label, size, styleName = "primary", value }) => {
    return (
        <>
            <div
                className={classNames("anomaly-detail", `anomaly-detail--${styleName}`, `anomaly-detail--size-${size}`)}
            >
                <span className="anomaly-detail__label">{label}</span>: {value}
            </div>{" "}
        </>
    );
};

export default AnomalyDetail;
